export const PROJECT_SET = 'project.set';
export const PROJECT_UNSET = 'project.unset';

export const FEATURE_ADD = 'feature.add';
export const FEATURE_REMOVE = 'feature.remove';

export const SCENARIO_ADD = 'scenario.add';
export const SCENARIO_TOGGLE_DONE = 'scenario.toggle.done';
export const SCENARIO_REMOVE = 'scenario.remove';

export const VOCABULARY_RESET = 'vocabulary.reset';
export const VOCABULARY_SET = 'vocabulary.set';
export const VOCABULARY_REMOVE = 'vocabulary.remove';
export const VOCABULARY_SET_USED = 'vocabulary.used.set';
export const VOCABULARY_NOUN_ADD = 'vocabulary.noun.add';
export const VOCABULARY_NOUN_REMOVE = 'vocabulary.noun.remove';
export const VOCABULARY_VERB_ADD = 'vocabulary.verb.add';
export const VOCABULARY_VERB_REMOVE = 'vocabulary.verb.remove';

export const BACKGROUND_SET = 'background.set';
export const BACKGROUND_RESET = 'background.reset';

export const DIAGRAM_SET = 'diagram.set';

export const TASK_ADD = 'task.add';
export const TASK_SET = 'task.set';
export const TASK_REMOVE = 'task.remove';
export const TASK_TOGGLE_DONE = 'task.toggle.done';
export const TASK_MARK_SCHEDULED = 'task.mark.scheduled';
export const TASK_SET_DAYS = 'task.set.days';
export const TASK_RESET = 'task.reset';
export const TASK_SET_TITLE = 'task.set.title';
export const TASK_TOGGLE_ARCHIVE = 'task.toggle.archive';
